// extracted by mini-css-extract-plugin
export default {"UnloadedContent":"UnloadedContent_UnloadedContent__0OXZq"};